export const translations = {
  de: {
    nav: {
      home: "Start",
      products: "Produkte",
      industrialPsu: "Industrial PSU",
      rackRails: "Rack Rails",
      about: "Über uns",
      contact: "Kontakt"
    },
    hero: {
      title: "Chenbro Servergehäuse & Zubehör",
      subtitle: "Professionelle Rackmount- und Tower-Serverlösungen",
      cta: "Produkte entdecken"
    },
    products: {
      title: "Produkte",
      subtitleSystems:
        "Servergehäuse und Plattformlösungen für professionelle IT-Infrastrukturen",
      all: "Alle",
      rackmount: "Rackmount",
      tower: "Tower",
      psu: "PSU",
      accessories: "Zubehör",
      cloud: "Cloud",
      storage: "Speicher",
      edge: "Edge",
      ai: "KI / AI",
      power: "Power",
      resultSingle: "Produkt",
      results: "Produkte",
      showMore: "Mehr anzeigen",
      brandChenbro: "Chenbro",
      pricePlaceholder: "Preis auf Anfrage"
    },
    rackRails: {
      title: "Rack Rails & Zubehör",
      subtitle: "Originales Chenbro Rack-Zubehör",
      description:
        "Schienensätze, Lüftermodule, Backplanes und Ersatzteile für Chenbro Serverchassis.",
      comingSoon: "Coming Soon"
    },
    industrialPsu: {
      title: "Industrial Power Supplies",
      subtitle: "AcBel & Seasonic Industrial PSU",
      description:
        "Hochverfügbare Stromversorgungen für Server und industrielle Anwendungen.",
      brandAcbel: "AcBel",
      brandSeasonic: "Seasonic Industrial"
    },
    about: {
      title: "Über FUM DA",
      subtitle: "Ihr Partner für Serverinfrastruktur",
      highlights: [
        { title: "Chenbro", desc: "Offizieller Distributor" },
        { title: "AcBel", desc: "Industrial PSU Partner" },
        { title: "Hamburg", desc: "Deutschland HQ" },
        { title: "EU-weit", desc: "Lieferung" }
      ]
    },
    contact: {
      title: "Kontakt",
      subtitle: "Sprechen Sie uns an",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      addressLabel: "Adresse"
    },
    footer: {
      brandDescription:
        "Professionelle Serverinfrastruktur, industrielle Stromversorgungen und Rack-Zubehör.",
      navigationTitle: "Navigation",
      legalTitle: "Rechtliches",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      rights: "Alle Rechte vorbehalten."
    }
  },

  en: {
    nav: {
      home: "Home",
      products: "Products",
      industrialPsu: "Industrial PSU",
      rackRails: "Rack Rails",
      about: "About",
      contact: "Contact"
    },
    hero: {
      title: "Chenbro Server Chassis & Accessories",
      subtitle: "Professional rackmount and tower server solutions",
      cta: "Discover Products"
    },
    products: {
      title: "Products",
      subtitleSystems:
        "Server chassis and platform solutions for professional IT infrastructures",
      all: "All",
      rackmount: "Rackmount",
      tower: "Tower",
      psu: "PSU",
      accessories: "Accessories",
      cloud: "Cloud",
      storage: "Storage",
      edge: "Edge",
      ai: "AI",
      power: "Power",
      resultSingle: "Product",
      results: "Products",
      showMore: "Load more",
      brandChenbro: "Chenbro",
      pricePlaceholder: "Price on request"
    },
    rackRails: {
      title: "Rack Rails & Accessories",
      subtitle: "Original Chenbro Rack Accessories",
      description:
        "Rail kits, fan modules, backplanes and spare parts for Chenbro server chassis.",
      comingSoon: "Coming Soon"
    },
    industrialPsu: {
      title: "Industrial Power Supplies",
      subtitle: "AcBel & Seasonic Industrial PSU",
      description:
        "High-availability power supplies for servers and industrial applications.",
      brandAcbel: "AcBel",
      brandSeasonic: "Seasonic Industrial"
    },
    about: {
      title: "About FUM DA",
      subtitle: "Your partner for server infrastructure",
      highlights: [
        { title: "Chenbro", desc: "Official Distributor" },
        { title: "AcBel", desc: "Industrial PSU Partner" },
        { title: "Hamburg", desc: "Germany HQ" },
        { title: "EU-wide", desc: "Delivery" }
      ]
    },
    contact: {
      title: "Contact",
      subtitle: "Get in touch",
      emailLabel: "Email",
      phoneLabel: "Phone",
      addressLabel: "Address"
    },
    footer: {
      brandDescription:
        "Professional server infrastructure, industrial power supplies and rack accessories.",
      navigationTitle: "Navigation",
      legalTitle: "Legal",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
      rights: "All rights reserved."
    }
  },

  es: {
    nav: {
      home: "Inicio",
      products: "Productos",
      industrialPsu: "PSU Industrial",
      rackRails: "Rieles Rack",
      about: "Nosotros",
      contact: "Contacto"
    },
    hero: {
      title: "Chasis de Servidor Chenbro & Accesorios",
      subtitle: "Soluciones profesionales rackmount y torre",
      cta: "Descubrir Productos"
    },
    products: {
      title: "Productos",
      subtitleSystems:
        "Chasis de servidor y soluciones de plataforma para infraestructuras TI profesionales",
      all: "Todos",
      rackmount: "Rackmount",
      tower: "Torre",
      psu: "PSU",
      accessories: "Accesorios",
      cloud: "Nube",
      storage: "Almacenamiento",
      edge: "Edge",
      ai: "IA",
      power: "Power",
      resultSingle: "Producto",
      results: "Productos",
      showMore: "Ver más",
      brandChenbro: "Chenbro",
      pricePlaceholder: "Precio bajo consulta"
    },
    rackRails: {
      title: "Rieles Rack & Accesorios",
      subtitle: "Accesorios Rack Chenbro Originales",
      description:
        "Kits de rieles, módulos de ventilador, backplanes y repuestos para chasis de servidor Chenbro.",
      comingSoon: "Próximamente"
    },
    industrialPsu: {
      title: "Fuentes de Alimentación Industriales",
      subtitle: "AcBel y Seasonic Industrial PSU",
      description:
        "Fuentes de alimentación de alta disponibilidad para servidores y aplicaciones industriales.",
      brandAcbel: "AcBel",
      brandSeasonic: "Seasonic Industrial"
    },
    about: {
      title: "Sobre FUM DA",
      subtitle: "Su socio en infraestructura de servidores",
      highlights: [
        { title: "Chenbro", desc: "Distribuidor Oficial" },
        { title: "AcBel", desc: "Partner PSU Industrial" },
        { title: "Hamburgo", desc: "Alemania HQ" },
        { title: "UE", desc: "Entrega" }
      ]
    },
    contact: {
      title: "Contacto",
      subtitle: "Contáctenos",
      emailLabel: "Correo",
      phoneLabel: "Teléfono",
      addressLabel: "Dirección"
    },
    footer: {
      brandDescription:
        "Infraestructura profesional para servidores, fuentes de alimentación industriales y accesorios rack.",
      navigationTitle: "Navegación",
      legalTitle: "Legal",
      impressum: "Aviso legal",
      datenschutz: "Política de privacidad",
      rights: "Todos los derechos reservados."
    }
  }
};
